import React, {Fragment} from "react";

const PageNotFound = () => (
    <Fragment>
        <h3>Page Not Found</h3>
    </Fragment>
);

export default PageNotFound;
